const PUBLIC_ROUTES = ["login-signup", "forgot-password", "signup"]; // routes accessible for guest users
const PUBLIC_ACCESSIBLE_ROUTES = [
  "location-brand-menu",
  "order",
  "order-token"
]; // routes accessible for loggedin & guest users

const ORDER_ROUTES = [
  "order-menu",
  "order-cart",
  "order-feedback",
  "order-address-id",
  "order-status-orderId"
]; // routes accessible for users with order token
const hasValidAuthState = (store) => {
  return (
    store.state.auth.user &&
    store.state.auth.user.uid &&
    store.state.auth.headers["access-token"] &&
    store.state.auth.headers["client"]
  );
};
const hasValidLocalVarisbles = () => {
  const uid = $nuxt.$ls.get("v2-uid");
  const token = $nuxt.$ls.get("v2-access-token");
  const client = $nuxt.$ls.get("v2-client");
  return uid && uid !== "" && token && token !== "" && client && client !== "";
};

export default function ({ $axios, $ls, redirect, route, store }) {
  //temporary fix for redirecting to correct route for old urls -START
  if (route.fullPath.includes("/v2/#")) {
    redirect(route.fullPath.replace("/v2/#", ""));
  }
  if (route.fullPath.includes("/v2")) {
    redirect(route.fullPath.replace("/v2", ""));
  }
  //temporary fix for redirecting to correct route for old urls -END

  if (
    !PUBLIC_ROUTES.includes(route.name) &&
    !PUBLIC_ACCESSIBLE_ROUTES.includes(route.name)
  ) {
    //Check authentication
    if (ORDER_ROUTES.includes(route.name)) {
      if (!store.state.order?.token) {
        const lsToken = $nuxt.$ls.get("store-token", "");
        if (!lsToken) {
          redirect("/order");
        } else {
          $axios.defaults.headers["Authorization"] = `Bearer ${lsToken}`;
          if (!store.state.order?.restaurantDetails?.restaurant_id) {
            store.dispatch("order/getInfo");
          }
        }
      }
    } else if (!hasValidAuthState(store)) {
      store.commit("misc/SET_REDIRECT_URL", route.path);
      if (!hasValidLocalVarisbles()) {
        redirect("/login-signup");
      } else {
        store.dispatch("auth/profile");
      }
    }
  } else if (hasValidAuthState(store) || hasValidLocalVarisbles()) {
    if (PUBLIC_ROUTES.includes(route.name)) {
      redirect("/reciever");
    }
  }

  //Check subscription
  if (
    store.state.restaurant.locationDetails.id &&
    new Date().getDate() !== store.state.restaurant.lastRestaurantInfoFetchedAt
  ) {
    store.dispatch("restaurant/getLocationDetails", false);
  }

  if (
    route?.name?.includes("menu-upload") &&
    !store?.state?.menu?.menuUploadRawData?.length
  ) {
    redirect("/menu");
  }
}
